// fucking parcel what is this trash?
// https://github.com/parcel-bundler/parcel/issues/3375
import 'regenerator-runtime/runtime';
import * as BrowserFS from 'browserfs';
import * as path from 'path';
import ZipFS from 'browserfs/dist/node/backend/ZipFS';

// Emscripten injects a bunch of globals on window once its loaded
declare global {
  interface Window {
    FS: any,
    Module: any,
  }
}

window["FS"] = <any>undefined;
let gameFS: any | undefined = undefined;
const statusElement = document.getElementById("status");
const progressElement = <HTMLProgressElement>document.getElementById("progress");
const spinnerElement = document.getElementById("spinner");
const Module = {
  arguments: <string[]>[],
  elementPointerLock: true,
  forcedAspectRatio: 4 / 3,
  FS: <any>undefined,
  preRun: [],
  postRun: [],
  preInit: [function(){
    if(!gameFS) throw new Error('failed to initalize filesystem');

    BrowserFS.initialize(gameFS);
    const BFS = new BrowserFS.EmscriptenFS();
    window.FS.createFolder(window.FS.root, 'radcade', true, true);
    window.FS.mount(BFS, {root: '/'}, '/radcade');
  }],

  last: {
    time: Date.now(),
    text: ''
  },

  print: function() {
      return function(e: Error) {
        console.error()
	1 < arguments.length && (e = new Error(Array.prototype.slice.call(arguments).join(" "))), console.log(e);
    }
  }(),

  printErr: function(e: Error) {
    1 < arguments.length && (e = new Error(Array.prototype.slice.call(arguments).join(" "))), console.error(e)
  },

  canvas: function() {
    var e = document.getElementById("canvas");
    if(e){
      e.addEventListener("webglcontextlost", function(e) {
        alert("WebGL context lost. You will need to reload the page.");
        e.preventDefault();
      }, !1);
      return e;
    }
  }(),


  setStatus: function(e: string) {
    if(Module.last || (Module.last = {
      time: Date.now(),
      text: ""
    }), e !== Module.last.text) {
      var t = e.match(/([^(]+)\((\d+(\.\d+)?)\/(\d+)\)/),
	  n = Date.now();
      if(!progressElement || !spinnerElement || !statusElement) return;

      t && n - Module.last.time < 30 ||
              (
                Module.last.time = n,
                Module.last.text = e,
                t ? (
                  e = t[1],
                  progressElement.value = 100 * parseInt(t[2]),
                  progressElement.max = 100 * parseInt(t[4]),
                  progressElement.hidden = !1,
                  spinnerElement.hidden = !1
                ) : (
                  progressElement.value = 0,
                  progressElement.max = 0,
                  progressElement.hidden = !0, e || (spinnerElement.hidden = !0)), statusElement.innerHTML = e)
    }
  },

  totalDependencies: 0,
  monitorRunDependencies: function(e: number) {
    this.totalDependencies = Math.max(this.totalDependencies, e);
    Module.setStatus(e ? "Preparing... (" + (this.totalDependencies - e) + "/" + this.totalDependencies + ")" : "All downloads complete.");
  },
};


Module.setStatus("Downloading...");

window.onerror = function() {
  Module.setStatus("Exception thrown, see JavaScript console");
  if(spinnerElement){
    spinnerElement.style.display = "none";
  }

  Module.setStatus = function(e) {
    e && Module.printErr(new Error("[post-exception status] " + e))
  }
};
window["Module"] = Module;

function searchFileSystem(fs: ZipFS, startPath: string, filter: RegExp, acc: string[] = []): string[]{
  if (!fs.existsSync(startPath)){
    console.log("no dir ",startPath);
    return acc;
  }

  var files=fs.readdirSync(startPath);
  for(var i=0;i<files.length;i++){
    var filename=path.join(startPath,files[i]);
    var stat = fs.statSync(filename, true);
    if (stat.isDirectory()){
      return searchFileSystem(fs, filename,filter, acc); //recurse
    }
    else if (filter.test(filename)) {
      console.log('-- found: ',filename);
      acc.push(filename);
    };
  };

  return acc;
};

let deltaFS: any = null;
var inMemoryFS = new BrowserFS.FileSystem.InMemory();

async function loadDosBox(){
  // fetch and mount the game zip
  const zipRes = await window.fetch('./dosbox/heroq.zip')
  if(!zipRes.body || !zipRes.headers){
    throw new Error('failed to load ROM data');
  }

  // KZ this code  will render a progress bar for downloading the rom
  // the Content-length header needs to be sent for this
  // Apache PHP does not send Content-Length when the file is gzipd
  // https://serverfault.com/questions/183843/content-length-not-sent-when-gzip-compression-enabled-in-apache
  /* const zipReader = zipRes.body.getReader();
   * const contentLength = zipRes.headers.get('Content-Length');
   * if(!contentLength) throw new Error('failed to load ROM data, no Content-Length');
   * progressElement.max = 100 * parseInt(contentLength);

   * const [receivedLength, chunks] = await new Promise(async (resolve) => {
   *   let chunks = [];
   *   let receivedLength = 0; // received that many bytes at the moment
   *   while(true) {
   *     const {done, value} = await zipReader.read();

   *     if (done) {
   *       resolve([receivedLength, chunks]);
   *       break;
   *     }

   *     if(value){
   *       chunks.push(value);
   *       receivedLength += value.length;
   *       progressElement.value = 100 * receivedLength;
   *     }

   *     console.log(`Received ${receivedLength} of ${contentLength}`)
   *   }
   * });
   * progressElement.hidden = !1;

   * let chunksAll = new Uint8Array(receivedLength); // (4.1)
   * let position = 0;
   * for(let chunk of chunks) {
   *   chunksAll.set(chunk, position); // (4.2)
   *   position += chunk.length;
   * } */

  // Step 4: concatenate chunks into single Uint8Array
  const zipABuff = await zipRes.arrayBuffer();
  const zipBuff = Buffer.from(zipABuff);
  const zipFS = new BrowserFS.FileSystem.ZipFS(zipBuff);

  //find the executable
  const executable = searchFileSystem(zipFS, '/', /(\.exe)|(\.bat)|(\.com)/gi);
  //TODO prob get the largest in filesize
  console.log('possible executables', executable);

  gameFS.getOverlayedFileSystems().readable.mount(
    '/radcade',
    zipFS
  );

  // load and modify the dosboxconf
  /* const confRes = await window.fetch('./dosbox/dosbox.conf');
   * const confABuff = await confRes.arrayBuffer();
   * const confBuff = Buffer.from(confABuff);

   * const flag_w: any = { isReadable: function() { return false; },
   *                isWriteable: function() { return true; },
   *                isTruncating: function() { return false; },
   *                isAppendable: function() { return false; },
   *                isSynchronous: function() { return false; },
   *                isExclusive: function() { return false; },
   *                pathExistsAction: function() { return 0; },
   *                pathNotExistsAction: function() { return 3; }
   * }; */



  //  gameFS.writeFileSync('/dosbox.conf', confBuff, null, flag_w, 0x1a4)

  const args = [];
  args.push(['-conf', '/radcade/dosbox.conf']);
  args.push(['-c', 'mount C: /radcade']);
  args.push(['-c', 'C:']);
  args.push(['-c', 'cd /radcade']);
  args.push(['-c', 'cd /radcade/heroq']);
  args.push(['-c', 'SCIV.exe']);

  Module.arguments =  args.flat();


  // load dosbox
  const dosboxScript = document.createElement('script');
  document.body.appendChild(dosboxScript);
  dosboxScript.src = './dosbox/dosbox.js';
}

if (BrowserFS.FileSystem.IndexedDB.isAvailable()) {
  const AsyncMirrorFS = BrowserFS.FileSystem.AsyncMirror;
  const IndexedDB = BrowserFS.FileSystem.IndexedDB;

  deltaFS = new AsyncMirrorFS(
    inMemoryFS,
    new IndexedDB(function(e: any){
      if (e) {
        console.warn('could not access IndexedDB will fall back to in memory file system');
        // we probably weren't given access;
        // private window for example.
        // don't fail completely, just don't
        // use indexeddb
        deltaFS = inMemoryFS;
        loadDosBox();
      } else {
        // Initialize deltaFS by copying files from async storage to sync storage.
        deltaFS.initialize(function (e: Error) {
          if(e) {
            console.error('delta init failure', e.stack);
            loadDosBox();
          }else{
            gameFS = new BrowserFS.FileSystem.OverlayFS(
              deltaFS,
              new BrowserFS.FileSystem.MountableFileSystem()
            );

            gameFS.initialize(function(e: Error) {
              if(e) {
                console.error('game fs failure', e.stack); throw e;
              }else{
                loadDosBox();
              }
            });
          }
        });
      }
    },'radcade'));
}

// insure game is focused if in iframe
// otherwise keyboard won't capture
// https://supernapie.com/blog/keyboard-focus-in-an-iframe/
window.addEventListener('load', function () {
  window.focus();
  document.body.addEventListener('click',function(e) {
    window.focus();
  },false);
});
